<template>
<div class="example-full">

  <!-- <button type="button" class="btn btn-danger float-right btn-is-option" @click.prevent="isOption = !isOption">
    <i class="fa fa-cog" aria-hidden="true"></i>
    Options
  </button> -->

  <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
    <h3>Arraste os arquivos aqui para enviar</h3>
  </div>

  <div class="upload" v-show="!isOption">
    <div class="table-responsive">
      <div v-if="!value || !value.length" class="drop-zone">
        <h4>Arraste os arquivos aqui</h4>
      </div>
      <v-layout row wrap>
        <v-flex
          v-for="(file, idx) in value"
          :key="idx"
          md4
          xs6
          ma5
        >
          <v-card>
            <a :href="file.url" target="_blank" v-if="file.uploaded">
              <v-img
                :src="file.url"
                @click="window.open('', file.url)"
              />
            </a>
            <v-img
              v-else
              :src="file.thumb"
            />

            <v-card-text v-if="!file.uploaded">
              <span v-if="file.name" v-text="file.name" /><br>
              <span v-if="file.size" v-text="`${Math.round(file.size/1024)}Kb`" />
            </v-card-text>

            <v-card-text v-else>
              <v-text-field
                v-model="file.title"
                label="Título"
              />
              <v-text-field
                v-model="file.subtitle"
                label="Subtítulo"
              />
              <v-text-field
                v-model="file.body"
                label="Corpo"
              />
              <v-text-field
                v-model="file.link"
                label="Link"
              />
              <v-text-field
                v-model="file.position"
                label="Posição"
              />
            </v-card-text>

            <v-card-actions>
              <v-chip v-if="file.uploaded" color="teal" text-color="white">
                <v-avatar>
                  <v-icon>check_circle</v-icon>
                </v-avatar>
                UPLOADED
              </v-chip>
              <v-icon
                @click.prevent="removeItem(file)"
                v-text="'delete'"
              />
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </div>

    <div class="example-foorer">
      <div class="btn-group">
        <file-upload
          class="v-btn theme--light default bt-selecionar-images"
          :extensions="extensions"
          :accept="accept"
          :multiple="multiple"
          :directory="directory"
          :size="size || 0"
          :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
          :data="data"
          :drop="drop"
          :drop-directory="dropDirectory"
          :add-index="addIndex"
          v-model="value"
          ref="upload"
        >
          Adicionar arquivos
        </file-upload>

        <v-btn
          @click="upload()"
          class="theme--light default bt-selecionar-images"
          :disabled="disableUploadButton"
        >
          <i class="fa fa-arrow-up" aria-hidden="true"></i>
          Upload
        </v-btn>
      </div>
    </div>
  </div>
</div>

</template>
<style lang="stylus">
  .example-full
    width 100%

    .btn-group
      margin-top 20px
      display flex
      justify-content space-between
      font-weight normal

    .btn-group .dropdown-menu
      display block
      visibility hidden
      transition all .2s

    .btn-group:hover > .dropdown-menu
      visibility visible

    label.dropdown-item
      margin-bottom 0

    .btn-group .dropdown-toggle
      margin-right .6rem

    .filename
      margin-bottom .3rem

    .btn-is-option
      margin-top 0.25rem

    .example-foorer
      padding .5rem 0
      border-top 1px solid #e9ecef
      border-bottom 1px solid #e9ecef

    .edit-image img
      max-width 100%

    .edit-image-tool
      margin-top .6rem

    .edit-image-tool .btn-group
      margin-right .6rem

    .footer-status
      padding-top .4rem

    .drop-active
      top 0
      bottom 0
      right 0
      left 0
      position fixed
      z-index 9999
      opacity .6
      text-align center
      background #000

    .drop-active h3
      margin -.5em 0 0
      position absolute
      top 50%
      left 0
      right 0
      -webkit-transform translateY(-50%)
      -ms-transform translateY(-50%)
      transform translateY(-50%)
      font-size 40px
      color #fff
      padding 0

.bt-selecionar-images
  display inline-flex !important
  align-items center
  width auto
  margin 0 10px 0 0

.drop-zone
  border 2px dotted #ddd
  padding 100px 30px
  background-color #f0f0f0
  text-align center
  margin-top 15px

.theme--light.v-sheet
  background-color #ddd

</style>

<script>
import uploadService from '../../../services/UploadService'
import { abstractField } from 'vue-form-generator'
import FileUpload from 'vue-upload-component'

export default {
  components: {
    FileUpload
  },
  data () {
    return {
      accept: 'image/png,image/gif,image/jpeg,image/webp',
      extensions: 'gif,jpg,jpeg,png,webp',
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      autoCompress: 1024 * 1024,
      uploadAuto: false,
      isOption: false,
      data: {
        // '_csrf_token': 'xxxxxx',
      },
      addData: {
        show: false,
        name: '',
        type: '',
        content: ''
      },
      editFile: {
        show: false,
        name: ''
      },
      uploading: false
    }
  },
  computed: {
    disableUploadButton () {
      return this.value && (this.value.filter(item => !item.uploaded).length === 0 || this.uploading)
    },
    entity () {
      return this.$route.meta.entity
    }
  },
  methods: {
    async upload () {
      this.uploading = true

      const collection = this.entity.collection
      const response = await uploadService(collection).uploadFile(this.value)

      if (response) {
        this.value = await response
      }
      this.uploading = false
    },
    async removeItem (file) {
      const collection = this.entity.collection
      this.value = this.value.filter(item => item.id !== file.id)

      if (file.uploaded) {
        const deleteResponse = await uploadService(collection).deleteFile(file.path)
        console.log(deleteResponse)
      }
    }
  },
  mixins: [abstractField]
}
</script>
